import { PropsWithChildren, useEffect } from "react";
import { useSessionContext } from "../context/SessionContext";
import { useGetSession } from "../api/useAuth";

export const ContextWrapper = (props: PropsWithChildren) => {
    const [setSession, setInitialized] = useSessionContext((state) => [state.setSession, state.setInitialized]);

    const sessionQuery = useGetSession();

    useEffect(() => {
        if (sessionQuery.isFetched && sessionQuery.isSuccess) {
            setSession(sessionQuery.data);
            setInitialized(true);
        } else if (sessionQuery.isFetched) {
            setInitialized(true);
        }
    }, [sessionQuery.isSuccess, sessionQuery.isFetched]);

    return <>{props.children}</>;
};
